// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__JDTa_","card-title":"Card_card-title__2vYKp","card-body":"Card_card-body__19gpw"};